import React from "react";
import axios from "axios";
import { connect } from "react-redux";
import cx from "classnames";
import { Table, TableBody, TableCell, TableFooter, TableHead, TableRow } from "@mui/material";
import { FreeBreakfast } from "@mui/icons-material";

import Card from "../../../components/Card/Card";
import CardBody from "../../../components/Card/CardBody";
import CardHeader from "../../../components/Card/CardHeader";
import CardIcon from "../../../components/Card/CardIcon";
import GridContainer from "../../../components/Grid/GridContainer";
import GridItem from "../../../components/Grid/GridItem";
import { formatValuta } from "../../../utils";
import Filters from "../Components/Filters";

import * as actions from "../../../store/actions";

import { withStyles } from "tss-react/mui";
import rapportenStyle from "../../../assets/jss/material-dashboard-pro-react/views/rapportenStyle";

import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper.tsx";
import { toast } from "react-toastify";
import { format } from "date-fns";

class Producten extends React.Component {
  state = {
    salesProductenOverPeriode: {
      items: {},
      totalen: {
        totaal: 0,
        totaalOpties: 0,
        totaalwaarde: 0,
        totaalwaardeex: 0,
        totaalbtw: 0,
      },
    },
  };

  currentRequest;

  /**
   * Get financial format
   */
  getNumberformat(value, currency = "EUR") {
    return new Intl.NumberFormat("nl-NL", {
      style: "currency",
      currency: currency.toUpperCase(),
      currencyDisplay: "symbol",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value);
  }

  getData = (filterData) => {
    toast.info(<TranslationWrapper tDefault={"laden"} tKey={"global.laden"} />);

    let data = {
      vestiging_ids: filterData.vestiging_ids,
      start_datum: format(new Date(filterData.start_datum), "yyyy-M-d HH:mm:ss"),
      eind_datum: format(new Date(filterData.eind_datum), "yyyy-M-d HH:mm:ss"),
      preordertimes: filterData.preordertimes,
    };

    if (this.currentRequest !== undefined) {
      this.currentRequest.cancel();
    }

    const CancelToken = axios.CancelToken;
    this.currentRequest = CancelToken.source();
    let cancelToken = this.currentRequest.token;

    axios
      .post("core/rapporten/sales_producten_genereer", data, {
        cancelToken: cancelToken,
      })
      .then((response) => {
        let newState = { ...this.state, ...response.data.data };
        this.setState(newState);
      })
      .catch((error) => {
        /**
         * Alleen niet CANCEL errors afvangen
         */
        if (!error.__CANCEL__) {
          toast.error(
            <TranslationWrapper tDefault={"Oeps er is iets misgegaan!"} tKey={"global.rapporten.errormessage"} />
          );
        }
      });
  };

  render() {
    const { classes } = this.props;

    return (
      <div>
        <Filters onFilterChange={this.getData} showEndDate showPreordertimes showStartDate showVestigingen />
        <GridContainer>
          <GridItem lg={12} md={12} sm={12} xs={12}>
            <Card>
              <CardHeader color={"primary"} icon>
                <CardIcon color={"primary"}>
                  <FreeBreakfast />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>
                  <TranslationWrapper
                    tDefault={"Verkoop over periode"}
                    tKey={"rapportages.rapporten.producten.verkoop.periode"}
                  />
                </h4>
              </CardHeader>
              <CardBody>
                <div className={classes.tableResponsive}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>
                          <TranslationWrapper
                            tDefault={"Productnaam"}
                            tKey={"rapportages.rapporten.producten.table.productnaam"}
                          />
                        </TableCell>
                        <TableCell>
                          <TranslationWrapper
                            tDefault={"Aantal"}
                            tKey={"rapportages.rapporten.producten.table.aantal"}
                          />
                        </TableCell>
                        <TableCell>
                          <TranslationWrapper
                            tDefault={"Incl. BTW"}
                            tKey={"rapportages.rapporten.producten.table.inclBtw"}
                          />
                        </TableCell>
                        <TableCell>
                          <TranslationWrapper
                            tDefault={"Excl.BTW"}
                            tKey={"rapportages.rapporten.producten.table.exclBtw"}
                          />
                        </TableCell>
                        <TableCell>
                          <TranslationWrapper tDefault={"BTW"} tKey={"rapportages.rapporten.producten.table.btw"} />
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {Object.keys(this.state.salesProductenOverPeriode.items).map((prop, key) => {
                        var tableRowClass = cx({
                          [classes.optionRow]: this.state.salesProductenOverPeriode.items[prop].isOptie,
                        });

                        return (
                          <TableRow className={tableRowClass} key={key}>
                            <TableCell>{this.state.salesProductenOverPeriode.items[prop].naam}</TableCell>
                            <TableCell>{this.state.salesProductenOverPeriode.items[prop].aantal}</TableCell>
                            <TableCell>
                              {formatValuta(this.state.salesProductenOverPeriode.items[prop].bedrag)}
                            </TableCell>
                            <TableCell>
                              {this.state.salesProductenOverPeriode.items[prop].exclbtw !== "-"
                                ? formatValuta(this.state.salesProductenOverPeriode.items[prop].exclbtw)
                                : this.state.salesProductenOverPeriode.items[prop].exclbtw}
                            </TableCell>
                            <TableCell>
                              {this.state.salesProductenOverPeriode.items[prop].btw !== "-"
                                ? formatValuta(this.state.salesProductenOverPeriode.items[prop].btw)
                                : this.state.salesProductenOverPeriode.items[prop].btw}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                    <TableFooter>
                      <TableRow className={classes.totalRow}>
                        <TableCell>
                          <b>
                            <TranslationWrapper tDefault={"Totaal"} tKey={"global.totaal"} />
                          </b>
                        </TableCell>
                        <TableCell>
                          <b>
                            {this.state.salesProductenOverPeriode.totalen.totaal} (
                            {this.state.salesProductenOverPeriode.totalen.totaalOpties})
                          </b>
                        </TableCell>
                        <TableCell>
                          <b>{formatValuta(this.state.salesProductenOverPeriode.totalen.totaalwaarde)}</b>
                        </TableCell>
                        <TableCell>
                          <b>{formatValuta(this.state.salesProductenOverPeriode.totalen.totaalwaardeex)}</b>
                        </TableCell>
                        <TableCell>
                          <b>{formatValuta(this.state.salesProductenOverPeriode.totalen.totaalbtw)}</b>
                        </TableCell>
                      </TableRow>
                    </TableFooter>
                  </Table>
                </div>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    showMessage: (message) => dispatch({ type: actions.SHOW_MESSAGE, message: message }),
    closeMessage: () => dispatch({ type: actions.CLOSE_MESSAGE }),
  };
};

export default connect(null, mapDispatchToProps)(withStyles(Producten, rapportenStyle));
